/*
 *
 *  * Copyright (c) 2021.
 *  * Md Naimul Hasan
 *  * naim886@gmail.com
 *  * 01719123886
 *  * www.naimbd.com
 *
 */

import React, {useEffect, useState} from 'react';
import {ToastContainer} from "react-toastify";
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Constants";

const Revenue = () => {
    const [revenue, setRevenue] = useState([]);
    const getRevenue = () => {
      axios.post(BASEURL+'/api/provider/provider-revenue', date).then(res=>{
          setRevenue(res.data)
      })
    }
    useEffect(() => {
        getRevenue()
    }, []);


    const [date, setDate] = useState([])
    const handleDateInput = (e) => {
        setDate(prev =>({...prev, [e.target.name] :e.target.value }))
    }

    const handleSearch = () => {
        setDate(prev =>({...prev, time: 'between' }))
        getRevenue()
    }

    const handleButtonInput = (e, time) => {
        if (time == 'all'){
            setDate(prev =>({...prev, time: 'all' }))
        }else if(time=='this'){
            setDate(prev =>({...prev, time: 'this' }))
        }else if(time=='prev'){
            setDate(prev =>({...prev, time: 'prev' }))
        }
    }

    useEffect(()=>{
        getRevenue()
    }, [date.time])


    return (
        <main>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="container-fluid px-4">
                <h1 className="mt-4">Revenue Details</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Revenue Details</li>
                </ol>
                <div className="my-card">
                    <div className="row">
                        <div className="col-md-6 text-start mb-1">
                            <button onClick={(e)=>handleButtonInput(e, 'all')} className={'btn btn-success btn-sm'}>All Time</button>
                            <button onClick={(e)=>handleButtonInput(e, 'this')} className={'btn btn-success btn-sm ms-1'}>Today</button>
                            <button onClick={(e)=>handleButtonInput(e, 'prev')} className={'btn btn-success btn-sm ms-1'}>Yesterday</button>
                        </div>
                        <div className="col-md-6 text-end mb-1">
                            <div className="row align-items-center">
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'start_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'end_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-2">
                                    <button onClick={handleSearch} className={'btn btn-success btn-sm ms-1'}>Search</button>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card bg-warning">
                                <div className="card-header">
                                    <h5>Total Order Amount</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.total_order_amount}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card bg-success">
                                <div className="card-header">
                                    <h5>Paid Order Amount</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.paid_order_amount}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card bg-info">
                                <div className="card-header">
                                    <h5>Total Paid Order</h5>
                                </div>
                                <div className="card-body">
                                    <h1>{revenue.total_paid_order}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-4">
                            <div className="card bg-info">
                                <div className="card-header">
                                    <h5>Total Revenue</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.total_revenue}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-4">
                            <div className="card bg-success">
                                <div className="card-header">
                                    <h5>Paid Revenue</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.paid_revenue}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-4">
                            <div className="card bg-danger">
                                <div className="card-header">
                                    <h5>Due Revenue</h5>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h1>${revenue.due_revenue}</h1>
                                        {revenue.due_revenue > 0 ?
                                            <button className={'btn btn-light'}>Pay Now</button>:null
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Revenue;
